module.exports = __webpack_public_path__ + "static/joel-dark-5d8443fdc9027f1e1ea21b99af6ca592.png";